import { Box, Heading, Text } from '@wix/design-system';
import {
  useAnonymous,
  useIsSeasonalSale,
} from '@wix/package-picker-shared-studio';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { StudioPackagePickerModule } from '../../../modules/studio-package-picker.module';
import { SelectButton } from '../../SelectButton';
import { StudioPrice } from '../../StudioPrice';
import { FeatureList } from './FeatureList';
import s from './ProductCard.scss';

const PLAN_NAME_HEIGHT = '68px';
const PRICE_MIN_HEIGHT = '54px';
const FULL_PRICE_LINE_HEIGHT = 24;
const PLAN_SUMMARY_HEIGHT = 187;

export const CARD_CONTENT_DATA_HOOKS = {
  price: 'card-content-price',
  selectButton: 'card-content-select-button',
};

interface CardContentProps {
  productId: string;
  isRecommended: boolean;
}

export const CardContent = ({ productId, isRecommended }: CardContentProps) => {
  const { isAnonymous } = useAnonymous();
  const isSeasonalSale = useIsSeasonalSale();
  const { data: product } =
    StudioPackagePickerModule.SDK.studioOfferingApiClient.hooks.useFetchProduct(
      { productId },
    );
  const { name, description, isEnterprise } = product ?? {};

  return (
    <Box direction="vertical" width="100%">
      <Box
        direction="vertical"
        height={`${
          PLAN_SUMMARY_HEIGHT + (isSeasonalSale ? FULL_PRICE_LINE_HEIGHT : 0)
        }px`}
        verticalAlign="space-between"
      >
        <ProductCardList.Default.Card.Header
          direction="vertical"
          width="100%"
          height={PLAN_NAME_HEIGHT}
          align="left"
          textAlign="left"
        >
          <Heading size="small" className={s.planName}>
            {name}
          </Heading>
          <Text size="small" className={s.planDescription}>
            {description}
          </Text>
        </ProductCardList.Default.Card.Header>
        <Box direction="vertical" width="100%" gap="SP2">
          <ProductCardList.Default.Card.Price
            dataHook={CARD_CONTENT_DATA_HOOKS.price}
            direction="vertical"
            align="left"
            minHeight={PRICE_MIN_HEIGHT}
            visibility={isEnterprise ? 'hidden' : 'visible'}
          >
            <StudioPrice productId={productId} />
          </ProductCardList.Default.Card.Price>
          {!isAnonymous && (
            <SelectButton
              dataHook={CARD_CONTENT_DATA_HOOKS.selectButton}
              productId={productId}
              filled={isRecommended}
              size="medium"
              source="cards"
            />
          )}
        </Box>
      </Box>
      <FeatureList productId={productId} />
    </Box>
  );
};
